import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import PopupAnnouncement from "./PopupAnnouncement";

export default function Layout() {
    return (
        <div className="min-h-screen flex flex-col bg-grain">
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <PopupAnnouncement />
        </div>
    );
}
